import React from 'react';

/**
 * Reusable ToggleInput component for switching between two options.
 *
 * @param {string} label - Optional label above the toggle control
 * @param {Array<{label: string, value: string|boolean}>} options - Array containing two option objects
 * @param {string|boolean} value - Currently active value
 * @param {function} onChange - Callback function triggered with the new selected value
 * @param {boolean} disabled - Optional disabled state
 */
const ToggleInput = ({
    label,
    options = [],
    value,
    onChange,
    disabled = false,
}) => {
    if (options.length < 2) return null;

    const optionLeft = options[0];
    const optionRight = options[1];

    const isLeftSelected = value === optionLeft.value;

    return (
        <div className="w-full">
            {label && (
                <label className="block text-xs font-medium text-zinc-700 mb-1">
                    {label}
                </label>
            )}
            <div
                className={`flex items-center p-1 bg-zinc-100 border border-zinc-200 rounded-lg select-none ${disabled ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
            >
                <button
                    type="button"
                    disabled={disabled}
                    onClick={() => onChange(optionLeft.value)}
                    className={`flex-1 py-1.5 px-3 text-xs font-medium rounded-md transition-all duration-200 ${isLeftSelected
                            ? 'bg-white text-blue-600 shadow-sm font-semibold'
                            : 'text-zinc-600 hover:text-zinc-900'
                        }`}
                >
                    {optionLeft.label}
                </button>
                <button
                    type="button"
                    disabled={disabled}
                    onClick={() => onChange(optionRight.value)}
                    className={`flex-1 py-1.5 px-3 text-xs font-medium rounded-md transition-all duration-200 ${!isLeftSelected
                            ? 'bg-white text-blue-600 shadow-sm font-semibold'
                            : 'text-zinc-600 hover:text-zinc-900'
                        }`}
                >
                    {optionRight.label}
                </button>
            </div>
        </div>
    );
};

export default ToggleInput;